function getPreChargeTypeDisplay (chargeType) {
  let display = this.chargeTypeList[chargeType]
  return display || chargeType
}

function getPreChargeDisplayLevel (remainedAmount) {
  if (remainedAmount < 0) {
    return 'table-danger'
  }
}

export default {
  data () {
    return {
      chargeTypeList: {
        bank_transfer: '银行转账',
        wechatpay: '微信支付',
        alipay: '支付宝',
        cash: '现金'
      }
    }
  },
  methods: {
    getPreChargeTypeDisplay,
    getPreChargeDisplayLevel
  }
}
